export const environment = {
  production: false,
  apiUrl: 'https://api.notascontabilisticas.pt/api',
  auth: {
    email: 'api@notascontabilisticas.pt',
    password: 'api@password_2022'
  }
};
